import type { ExerciseTypeConfig } from '../registry/types';
import type { FileUploadExerciseDefinition, FileUploadExerciseSubmission } from '../types';
import { fileUploadSubmissionSchema } from '../types/schemas';

/**
 * File Upload exercise type configuration.
 * Students upload files; teacher grades manually.
 */
export const fileUploadConfig: ExerciseTypeConfig<
  'FileUpload',
  FileUploadExerciseDefinition,
  FileUploadExerciseSubmission,
  { kind: string }
> = {
  type: 'FileUpload',
  isAutoGradable: false,
  submissionSchema: fileUploadSubmissionSchema,

  defaultMaxScore: (_definition) => {
    return 100;
  },

  hydrateDetails: (_serverDetails: unknown) => {
    // FileUpload has no extra details beyond the base exercise fields
    return {};
  },

  createDefault: (_order) => ({
    type: 'FileUpload' as const,
  }),
};
